module.exports = __webpack_public_path__ + "img/logo.ba00f1f5.png";